import { render, staticRenderFns } from "./BannerMtLinkSlider.vue?vue&type=template&id=790243e9&scoped=true&"
import script from "./BannerMtLinkSlider.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BannerMtLinkSlider.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BannerMtLinkSlider.vue?vue&type=style&index=0&id=790243e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790243e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790243e9')) {
      api.createRecord('790243e9', component.options)
    } else {
      api.reload('790243e9', component.options)
    }
    module.hot.accept("./BannerMtLinkSlider.vue?vue&type=template&id=790243e9&scoped=true&", function () {
      api.rerender('790243e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BannerMtLink/components/BannerMtLinkSlider.vue"
export default component.exports